import Highway from '@dogstudio/highway';
import store from '../util/store';
import LinksAnimation from '../animation/LinksAnimation';

export default class LinksTransition extends Highway.Transition {
  in({from, to, done}) {
    new LinksAnimation(from, to, done);
  }

  out({ done }) {
    if (!document.body.classList.contains('locked')) {
      store.lockBody();
    }
    done();
  }
}



// WEBPACK FOOTER //
// ./scripts/navigation/LinksTransition.js